export default {
  common: {
    appName: 'ElderCare',
    loading: 'Laddar...',
    retry: 'Försök igen',
    goBack: 'Hem',
    logout: 'Logga ut',
    save: 'Spara',
    cancel: 'Avbryt',
    confirm: 'Bekräfta',
    delete: 'Ta bort',
    edit: 'Redigera',
    search: 'Sök',
    weekDays: {
      sun: 'Sön',
      mon: 'Mån',
      tue: 'Tis',
      wed: 'Ons',
      thu: 'Tor',
      fri: 'Fre',
      sat: 'Lör',
    },
  },
  nav: {
    home: 'Hem',
    login: 'Logga in',
    dashboard: 'Översikt',
    health: 'Hälsa',
    medication: 'Läkemedel',
    sos: 'Nödsituation',
    family: 'Familj',
    article: 'Artiklar',
    checkin: 'Check-in',
    settings: 'Inställningar',
    about: 'Om',
  },
  footer: {
    rights: 'Alla rättigheter förbehållna',
    privacy: 'Integritetspolicy',
    terms: 'Villkor',
  },
  index: {
    hero: {
      title: 'ElderCare - Smart hälsövakt för äldre',
      subtitle: 'Hälsoplattform designad för äldre, håller familjer informerade och äldre friska',
      cta: 'Kom igång',
      learnMore: 'Läs mer',
    },
    features: {
      title: 'Huvudfunktioner',
      health: { title: 'Hälsövervakning', desc: 'Spela blodtryck, blodsocker och puls med smarta varningar' },
      medication: { title: 'Läkemedelshantering', desc: 'Påminnelser och interaktionskontroll, glöm aldrig en dos' },
      sos: { title: 'Nödsamtal', desc: 'SOS med en touch, automatisk familjenotifiering och platsdelning' },
      family: { title: 'Familjeomsorg', desc: 'Fjärrövervakning, omedelbara varningar och datadelning för familjer' },
      article: { title: 'Hälsoartiklar', desc: 'Tillförlitlig medicinsk kunskap och personliga hälsoguider' },
      checkin: { title: 'Daglig check-in', desc: 'Enkel daglig spårning för hälsosamma vanor' },
    },
    elderly: {
      title: 'Design för äldre',
      desc: 'Designat för äldre: lätt att använda, se och röra',
      font: 'Stora teckensnitt',
      touch: 'Stora tryckytor',
      contrast: 'Högkontrastfärger',
    },
  },
  login: {
    title: 'ElderCare',
    loginTab: 'Logga in',
    registerTab: 'Registrera',
    name: 'Namn',
    email: 'E-post',
    password: 'Lösenord',
    role: 'Jag är',
    elderRole: 'Äldre',
    familyRole: 'Familjemedlem',
    bindCode: 'Kopplingskod',
    bindCodeHint: 'Ange kopplingskoden från den äldres konto för att koppla och visa hälsodata',
    loginBtn: 'Logga in',
    registerBtn: 'Registrera',
    verifyHint: 'Ett verifieringsmail skickas till din adress efter registrering',
    error: 'Åtgärden misslyckades, försök igen',
    nameTooShort: 'Namnet måste vara minst 2 tecken',
    emailInvalid: 'Ange en giltig e-postadress',
    passwordTooShort: 'Lösenordet måste vara minst 8 tecken',
  },
  dashboard: {
    title: 'Hälsöversikt',
    metrics: {
      bloodPressure: 'Blodtryck',
      bloodSugar: 'Blodsocker',
      heartRate: 'Puls',
      weight: 'Vikt',
      sleep: 'Sömn',
      temperature: 'Temperatur',
    },
    quickActions: 'Snabbåtgärder',
    recordHealth: 'Registrera hälsa',
    takeMedicine: 'Ta medicin',
    sos: 'Nödsamtal',
    checkinStatus: 'Check-in idag',
    checkedIn: 'Incheckad idag',
    notCheckedIn: 'Ej incheckad idag',
    goCheckin: 'Checka in',
    medicationReminders: 'Läkemedelspåminnelser',
    noReminders: 'Inga läkemedelspåminnelser',
    taken: 'Tagen',
  },
  health: {
    title: 'Hälsojournal',
    inputTitle: 'Datainmatning',
    systolic: 'Systoliskt (mmHg)',
    diastolic: 'Diastoliskt (mmHg)',
    bloodSugar: 'Blodsocker (mmol/L)',
    heartRate: 'Puls (bpm)',
    weight: 'Vikt (kg)',
    sleepHours: 'Sömn (timmar)',
    temperature: 'Temperatur (°C)',
    submit: 'Skicka registrering',
    trend: 'Trender',
    days: 'dagar',
    aiAnalysis: 'AI-hälsanalys',
    analyze: 'Analysera',
    noAnalysis: 'Klicka på knappen ovan för att få en AI-hälsanalysrapport',
    history: 'Historik',
    noHistory: 'Ingen historik',
    chartLabelSystolic: 'Systoliskt tryck',
    atLeastOneField: 'Fyll i minst ett hälsovärde',
  },
  medication: {
    title: 'Läkemedelshantering',
    currentPlan: 'Nuvarande plan',
    noMedications: 'Inga läkemedel',
    addMedication: 'Lägg till läkemedel',
    name: 'Läkemedelsnamn',
    dosage: 'Dosering',
    frequency: 'Frekvens',
    freqDaily: 'En gång dagligen',
    freqTwice: 'Två gånger dagligen',
    freqThree: 'Tre gånger dagligen',
    freqWeekly: 'En gång i veckan',
    time: 'Tid',
    startDate: 'Startdatum',
    addBtn: 'Lägg till',
    interactionWarning: 'Interaktionsvarning',
    noInteraction: 'Inga interaktionsrisker',
    calendar: 'Läkemedelskalender',
    invalidTimeFormat: 'Ogiltigt tidsformat, använd HH:mm (t.ex., 08:00, 20:00)',
  },
  sos: {
    title: 'Nödsamtal',
    holdToCall: 'Håll för att ringa',
    holdHint: 'Håll i 1 sekund för att aktivera nödsamtal',
    sent: 'Nödsamtal skickat',
    sentDesc: 'Dina nödkontakter har notifierats. Håll lugnet och vänta på hjälp',
    contacts: 'Nödkontakter',
    location: 'Nuvarande plats',
    loadingLocation: 'Hämtar plats...',
    locationUnavailable: 'Plats ej tillgänglig',
    history: 'SOS-historik',
    noHistory: 'Inga SOS-registreringar',
    confirmed: 'Bekräftad',
    pending: 'Väntande',
  },
  family: {
    title: 'Familjeomsorg',
    members: 'Kopplad familj',
    noMembers: 'Inga kopplade familjemedlemmar',
    bindCode: 'Kopplingskod',
    bindCodeHint: 'Dela denna kod med familjen för att koppla konton',
    invite: 'Bjud in familj',
    email: 'Familjens e-post',
    relationship: 'Relation',
    relSon: 'Son',
    relDaughter: 'Dotter',
    relSpouse: 'Make/Maka',
    relSibling: 'Syskon',
    relOther: 'Annat',
    inviteBtn: 'Skicka inbjudan',
    notifications: 'Aviseringsinställningar',
    prefAbnormal: 'Hälsoavvikelse-varning',
    prefMedication: 'Läkemedelspåminnelse',
    prefSos: 'Nödvarning',
    prefWeekly: 'Veckorapport',
    prefCheckin: 'Check-in avisering',
    dataSharing: 'Datadelning',
    shareDesc: 'Tillåt familjen att se dina hälsodata',
    inviteSent: 'Inbjudan skickad',
    inviteFailed: 'Kunde inte skicka inbjudan, försök igen',
    invalidEmail: 'Ange en giltig e-postadress',
  },
  article: {
    title: 'Hälsoartiklar',
    search: 'Sök artiklar...',
    noArticles: 'Inga artiklar hittades',
    expand: 'Läs mer',
    collapse: 'Dölj',
    categories: {
      all: 'Alla',
      heart: 'Hjärt-kärlsjukdomar',
      diabetes: 'Diabetes',
      bone: 'Ben',
      sleep: 'Sömn',
      nutrition: 'Näring',
      exercise: 'Träning',
    },
  },
  checkin: {
    title: 'Daglig check-in',
    feeling: 'Hur mår du idag?',
    feelings: {
      great: 'Utmärkt',
      good: 'Bra',
      normal: 'Okej',
      bad: 'Dåligt',
      terrible: 'Förfärligt',
    },
    medication: 'Läkemedel idag',
    yes: 'Ja',
    no: 'Nej',
    diet: 'Kostbedömning',
    dietRatings: {
      good: 'Bra',
      normal: 'Okej',
      poor: 'Dålig',
    },
    exercise: 'Träning idag',
    mood: 'Humör',
    submit: 'Skicka check-in',
    streak: 'Svit',
    streakDays: 'dagar',
    calendar: 'Check-in kalender',
  },
  settings: {
    title: 'Inställningar',
    profile: 'Profil',
    name: 'Användarnamn',
    phone: 'Telefon',
    birthday: 'Födelsedatum',
    emergencyContact: 'Nödkontakt',
    save: 'Spara ändringar',
    preferences: 'Inställningar',
    language: 'Språk',
    theme: 'Tema',
    light: 'Ljus',
    dark: 'Mörk',
    notifications: 'Aviseringar',
    notifHealth: 'Hälsovarningar',
    notifMedication: 'Läkemedelspåminnelser',
    notifSos: 'Nödvarningar',
    notifCheckin: 'Check-in påminnelser',
    bindCode: 'Min kopplingskod',
    changePassword: 'Ändra lösenord',
    currentPassword: 'Nuvarande lösenord',
    newPassword: 'Nytt lösenord',
    changePasswordBtn: 'Ändra lösenord',
    dangerZone: 'Riskzon',
    deleteDesc: 'Kontoborttagning är oåterkallelig. All data går förlorad',
    deleteAccount: 'Ta bort konto',
    deleteConfirm: 'Är du säker? Denna åtgärd är oåterkallelig!',
  },
  about: {
    title: 'Om ElderCare',
    subtitle: 'Smart hälsövakt för äldre',
    intro: 'Introduktion',
    introContent: 'ElderCare är en hälsoplattform för äldre med smart övervakning, läkemedelshantering, nödsamtal och mycket mer, som hjälper äldre att hantera sin hälsa och hålla kontakten med familjen.',
    version: 'Versionsinformation',
    versionNumber: 'Versionsnummer',
    buildDate: 'Byggdatum',
    acknowledgements: 'Tack',
    contact: 'Kontakt',
    contactEmail: "q3300404157{'@'}gmail.com",
    privacy: 'Integritetspolicy',
    terms: 'Villkor',
  },
  notfound: {
    message: 'Tyvärr, sidan du letar efter finns inte',
    goHome: 'Tillbaka hem',
  },
  privacy: {
    title: 'Integritetspolicy',
    sections: {
      collection: {
        title: 'Insamling av information',
        content: 'Vi samlar bara in personlig information som är nödvändig för att tillhandahålla våra tjänster, inklusive registreringsuppgifter (e-post, namn), hälsodata (blodtryck, blodsocker och andra indikatorer) och enhetsinformation. Vi samlar inte in personlig information som inte är relaterad till våra tjänster.',
      },
      usage: {
        title: 'Användning av information',
        content: 'Din personliga information används enbart för att tillhandahålla och förbättra tjänster, inklusive hälsodataanalys, avvikelsevarningar, läkemedelspåminnelser och andra kärnfunktioner. Vi kommer inte att använda din information för obehöriga ändamål.',
      },
      storage: {
        title: 'Lagring av information',
        content: 'Dina data lagras på säkra molnservrar med krypterad överföring och lagring. Vi vidtar rimliga tekniska åtgärder för att skydda säkerheten för dina data och förhindra obehörig åtkomst.',
      },
      sharing: {
        title: 'Delning av information',
        content: 'Utan ditt uttryckliga samtycke delar vi inte din personliga information med tredje part. Hälsodata delas med kopplade familjemedlemmar först efter din auktorisering av familjekopplingen.',
      },
      rights: {
        title: 'Dina rättigheter',
        content: 'Du har rätt att få tillgång till, korrigera och ta bort din personliga information, samt att återkalla ditt samtycke. Du kan utöva dessa rättigheter via inställningarna i appen eller genom att kontakta vårt supportteam.',
      },
      security: {
        title: 'Säkerhet',
        content: 'Vi använder kryptering och säkerhetsåtgärder som följer branschstandard för att skydda dina data, inklusive SSL-krypterad överföring, krypterad datalagring och åtkomstkontroll. Vi granskar och uppdaterar regelbundet våra säkerhetsåtgärder.',
      },
    },
  },
  terms: {
    title: 'Villkor',
    sections: {
      acceptance: {
        title: 'Acceptans av villkor',
        content: 'Genom att använda denna app accepterar du dessa villkor. Om du inte samtycker till någon del av dessa villkor, vänligen sluta använda appen. Vi förbehåller oss rätten att ändra dessa villkor när som helst.',
      },
      service: {
        title: 'Tjänstebeskrivning',
        content: 'ElderCare erbjuder stöd för hälsokontroll, inklusive registrering av hälsodata, läkemedelspåminnelser, nödsamtal och andra funktioner. Denna tjänst är endast informativ och utgör inte medicinsk rådgivning, och kan inte ersätta professionella medicinska tjänster.',
      },
      accounts: {
        title: 'Kontohantering',
        content: 'Du behöver registrera ett konto för att använda kärnfunktionerna i denna app. Du är ansvarig för säkerheten för ditt lösenord och all aktivitet under ditt konto. Om du upptäcker obehörig användning av ditt konto, vänligen meddela oss omedelbart.',
      },
      data: {
        title: 'Data och integritet',
        content: 'Vi värdesätter skyddet av din integritet. För detaljerade regler om databehandling, se vår Integritetspolicy. Du behåller full kontroll över de hälsodata du skickar in.',
      },
      liability: {
        title: 'Ansvarsbegränsning',
        content: 'Hälsoinformationen som tillhandahålls av denna app är endast informativ och utgör inte medicinsk diagnos eller behandlingsråd. Vi ansvarar inte för förluster som uppstår vid användning av information från denna app. Vid hälsoproblem, kontakta en kvalificerad vårdpersonal.',
      },
      changes: {
        title: 'Ändringar av villkor',
        content: 'Vi kan uppdatera dessa villkor från tid till annan. Betydande ändringar kommer att meddelas via aviseringar i appen eller via e-post. Fortsatt användning av denna app utgör acceptans av de uppdaterade villkoren.',
      },
    },
  },
  feedback: {
    title: 'Feedback',
    subtitle: 'Din feedback är mycket viktig för oss',
    name: 'Namn',
    namePlaceholder: 'Ange ditt namn (valfritt)',
    email: 'E-post',
    emailPlaceholder: 'Ange din e-post',
    subject: 'Ämne',
    subjectGeneral: 'Allmän feedback',
    subjectBug: 'Felrapport',
    subjectFeature: 'Funktionsförslag',
    subjectOther: 'Annat',
    message: 'Meddelande',
    messagePlaceholder: 'Beskriv din feedback i detalj...',
    submit: 'Skicka feedback',
    submitting: 'Skickar...',
    success: 'Feedback skickad! Tack för ditt bidrag',
    error: 'Det gick inte att skicka feedback, försök igen senare',
  },
  verify: {
    loading: 'Verifierar din e-post...',
    success: 'Verifiering lyckades!',
    successDesc: 'Din e-post har verifierats. Du kan nu logga in',
    failed: 'Verifiering misslyckades',
    failedDesc: 'Verifieringslänken är ogiltig eller har gått ut. Skicka verifieringsmeddelandet igen',
    resend: 'Skicka verifieringsmeddelande igen',
    resending: 'Skickar...',
    goLogin: 'Gå till inloggning',
  },
  theme: {
    light: 'Ljus',
    dark: 'Mörk',
  },
}
